import './styles.scss';

export default function ToyotaStripe() {
  return <div className="toyota-stripe" />;
}
